const lazyForPersonalUsersPageComponent = () => import('@/Pages/En/ForPersonalUsers.vue');

export const forPersonalUsersRoutes = [
  {
    path: '/for-personal-users',
    pathname: '/for-personal-users',
    name: 'for-personal-users',
    component: lazyForPersonalUsersPageComponent,
    meta: {
      name: 'for-personal-users',
      title: 'Personal Users - Create AI Floor Plans for Your Home',
    },
  },
];
